import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 0,
    padding: theme.spacing(2, 4),
    alignItems: 'baseline',

    [theme.breakpoints.down('xs')]: {
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2),
    },
    '&.MuiAlert-standardInfo': {
      backgroundColor: fade(theme.palette.primary.lighter, 0.3),
      color: theme.palette.primary.light,
      '& > .MuiAlert-icon': {
        color: theme.palette.primary.light,
      },
    },
    '&.MuiAlert-standardError': {
      backgroundColor: fade(theme.palette.error.light, 0.3),
      color: theme.palette.error.dark,
    },
    '& .MuiAlert-icon': {
      padding: 0,
    },
    '& .MuiAlert-message': {
      alignSelf: 'center',
      padding: theme.spacing(0.5, 0),
      fontSize: 12,
      fontWeight: 500,
      lineHeight: 1.33,
    },
  },
}))

export default useStyles
